export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_04_alt.01ac9cd4.mp4";